// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mooimuhyywrklperuerj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1vb2ltdWh5eXdya2xwZXJ1ZXJqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE2MTIwODEsImV4cCI6MjA5NzE4ODA4MX0.-KDl3L_aTRdDTOmVyOZFPiCPObfPzGK6uFwbNSSMNS0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});